import { render } from "./ResourceLabeledSelect.vue?vue&type=template&id=fc14794a&ts=true"
import script from "./ResourceLabeledSelect.vue?vue&type=script&lang=ts"
export * from "./ResourceLabeledSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__